<template>
  <div class="question-view">
    <p class="question-view-title">{{ prefix }}</p>
    <p class="question-view-title">{{ title }}</p>
    <van-radio-group class="question-view-options" v-model="selectedIndex"
      v-if="currentStyle == 2 || currentStyle == 1">
      <div class="question-view-options-cell" v-for="(item, index) of optionArray" :key="index"
        @click="onSelected(index)">
        <div class="question-view-options-cell-container" :class="{
          'question-view-options-cell-container-last':
            index == optionArray.length - 1,
        }">
          <van-radio :name="index" checked-color="#596afd">{{
            item
            }}</van-radio>
        </div>
      </div>
    </van-radio-group>

    <template v-if="hasChildQuestion && [1, 2, 3].some(el => el === selectedIndex)">
      <!-- 子问题，先写死 -->
      <p class="question-view-title question-view-title-child">{{ childQuestionTitle }}</p>
      <van-field class="question-view-input question-view-input-child" v-model="childValue" label="" placeholder="请输入"
        @input="onChildChange" />
    </template>
    <van-field class="question-view-choice" v-model="timeValue" v-if="currentStyle == 4" is-link readonly label="时间"
      placeholder="请选择时间" @click="showTimePicker = true" />

    <van-field class="question-view-choice" v-model="clcokValue"
      v-if="currentStyle == 6 || currentStyle == 7 || currentStyle == 8" is-link readonly label="时间" placeholder="请选择时间"
      @click="showTimePicker = true" />
    <van-popup v-model="showTimePicker" round position="bottom">
      <van-picker title="选择时间" show-toolbar :columns="columns" @confirm="onConfirmTimePicker"
        @cancel="onCancelTimePicker" @change="onTimeChange" />
    </van-popup>

    <van-field class="question-view-input" v-model="countValue" v-if="currentStyle == 3" label="次数" placeholder="请输入次数"
      @input="onCountChange" type="digit" />

    <van-radio-group v-if="currentStyle == 5" class="question-view-mix" v-model="minuteselectedIndex">
      <van-field class="question-view-mix-input" v-model="minuteValue" placeholder="请输入时间" @input="onMinuteChange"
        type="digit" label="分钟" />
      <div>
        <van-radio class="question-view-mix-radio" name="1" checked-color="#596afd">不知道</van-radio>
      </div>
    </van-radio-group>
  </div>
</template>

<script>
var _15Step = [{ text: '00', value: 0 }, { text: '15', value: 15 }, { text: '30', value: 30 }, { text: '45', value: 45 }]
export default {
  props: {
    model: Object,
    initialResultValue: Number,
    currentQuestionIndex: Number,
    initialResultStringValue: String
  },

  data() {
    return {
      selectedIndex: null,
      showTimePicker: false,
      currentTime: undefined,
      columns: [],
      timeValue: '',
      timeDefaultIndex1: 0,
      timeDefaultIndex2: 0,
      secondsAnswer: '',
      countValue: '',
      minuteValue: '',
      minuteselectedIndex: null,
      clcokValue: '',
      childValue: ''
    }
  },

  computed: {
    currentStyle() { 
      return this.model?.style
    },
    title() {
      return this.model?.assessmentName
    },

    prefix() {
      return this.model?.subtitle
    },

    optionArray() {
      return this.model?.desc ?? []
    },


    resultValueArray() {
      return this.model?.value ?? []
    },

    initialSelectedIndex() {
      return this.resultValueArray.indexOf(this.initialResultValue)
    },
    hasChildQuestion() {
      return !!this.model?.childQuestion
    },

    childQuestionTitle() { 
      return this.model?.childQuestion?.assessmentName ?? ''
    }
  },

  created() {

    this.selectedIndex = this.initialSelectedIndex
  },

  watch: {
    // 不在initialSelectedIndex中观察是因为它并不是每次切换题目都改变
    model(value) {
      if (value.style == 4) {
        if (this.initialResultValue == undefined || this.initialResultValue == NaN) {
          this.timeValue = ''
        } else {
          this.timeValue = this.getTimes(this.initialResultValue)
        }

        this.timePickerDesc()

      } else if (value.style == 3) {
        if (this.initialResultValue == undefined) {
          this.countValue = ''
        } else {
          this.countValue = this.initialResultValue
        }
      } else if (value.style == 6 || value.style == 7 || value.style == 8) {
        if (this.initialResultStringValue == undefined) {
          this.clcokValue = ''
        } else {
          this.clcokValue = this.initialResultStringValue
        }
        if (this.model.desc[0] === '__小时__分钟') {
          this.clcokValue = ''
        }
        this.clcokPickerDesc()
      }
      this.selectedIndex = this.initialSelectedIndex
    },
    currentQuestionIndex(newValue) {

    },

    minuteselectedIndex(newValue) {
      if (newValue == '1') {
        this.minuteValue = ''
        this.$emit('onAnsweredTime', {
          questionID: this.model.assessmentId,
          value: -2,
          style: this.currentStyle
        })
      }
    }

  },

  methods: {

    clcokPickerDesc() {

      if (this.clcokValue == '') {
        this.clcokValue = this.model.desc[0]
      }
  
      if (this.currentStyle == 6) {
        var a = this.clcokValue.indexOf(":");
        var b = this.clcokValue.substring(0, a);
        var c = this.clcokValue.length;
        var d = this.clcokValue.substring(a + 1, c)
        this.timeDefaultIndex1 = Number(b)
        this.timeDefaultIndex2 = Number(d)
      } else if (this.currentStyle == 7) { 
        this.timeDefaultIndex1 = Number(3)
        this.timeDefaultIndex2 = Number(0)
      } else if (this.currentStyle == 8) {
        if (this.model.assessmentId === 381) {
          this.timeDefaultIndex1 = Number(6)
        } else if (this.model.assessmentId === 382) { 
          this.timeDefaultIndex1 = Number(7)
        }
        this.timeDefaultIndex2 = Number(d)
      }

      this.$emit('onAnsweredTime', {
        questionID: this.model.assessmentId,
        value: this.clcokValue,
        style: this.currentStyle
      })
      this.onColumns()
    },
    timePickerDesc() {
      if (this.timeValue == '') {
        if (this.model.desc[0] == '__小时__分钟') {
          this.timeValue = ''
        } else {
          this.timeValue = this.model.desc[0]
          var a = this.timeValue.indexOf("小时");
          var b = this.timeValue.substring(0, a);
          var c = this.timeValue.indexOf("时");
          var d = this.timeValue.indexOf("分");
          var e = this.timeValue.substring(c + 1, d);
          this.timeDefaultIndex1 = Number(b)
          this.timeDefaultIndex2 = Number(e)
          this.secondsAnswer = (Number(b) * 60 + Number(e)) * 60

          this.$emit('onAnsweredTime', {
            questionID: this.model.assessmentId,
            value: this.secondsAnswer,
            style: this.currentStyle
          })
        }

      }

      this.onColumns()
    },
    getTimes(t) {
      let h = Math.floor(t / 3600); // 计算小时数
      let m = Math.floor((t % 3600) / 60); // 计算剩余分钟数
      return `${h}小时${m}分钟`
    },
    onConfirmTimePicker(value, index) {
      if (this.currentStyle == 4) {
        this.timeValue = value[0].value + "小时" + value[1].value + '分钟'
        this.showTimePicker = false
        this.secondsAnswer = (value[0].value * 60 + value[1].value) * 60

        this.$emit('onAnsweredTime', {
          questionID: this.model.assessmentId,
          value: this.secondsAnswer,
          style: this.currentStyle
        })
      } else if (this.currentStyle == 6 || this.currentStyle === 7 || this.currentStyle === 8) {
        let hour = value[0].value < 10 ? "0" + value[0].value : value[0].value;
        let minute = value[1].value < 10 ? "0" + value[1].value : value[1].value;

        this.clcokValue = hour + ":" + minute
        this.showTimePicker = false
        this.$emit('onAnsweredTime', {
          questionID: this.model.assessmentId,
          value: this.clcokValue,
          style: this.currentStyle
        })
      }

    },
    onCancelTimePicker() {
      this.showTimePicker = false
    },
    onCountChange(value) {
      this.$emit('onAnsweredCount', {
        questionID: this.model.assessmentId,
        value: Number(this.countValue),
        style: this.currentStyle
      })
    },
    onMinuteChange(value) {
      this.minuteselectedIndex = null
      this.$emit('onAnsweredTime', {
        questionID: this.model.assessmentId,
        value: Number(this.minuteValue),
        style: this.currentStyle
      })
    },
    onSelected(index) {
      this.selectedIndex = index
      if (this.hasChildQuestion) {
        this.$emit('onAnsweredHasChildQuestion', {
          questionID: this.model.assessmentId,
          value: this.resultValueArray[index],
          style: this.currentStyle
        })
      } else { 
        this.$emit('onAnswered', {
          questionID: this.model.assessmentId,
          value: this.resultValueArray[index],
          style: this.currentStyle
        })
      }
    },

    onChildChange(value) { 
      this.$emit('onAnsweredHasChildQuestion', {
        questionID: this.model.childQuestion.assessmentId,
        value: value,
        style: this.currentStyle
      })
    },

    onColumns() {
      let valueArray1 = []
      let valueArray2 = []
      if (this.currentStyle === 7 || this.currentStyle === 8) {
        let hStart = 18, hEnd = 32
        if (this.currentStyle === 8) {
          hStart = 0
          hEnd = 12
        }
        for (let index = hStart; index <= hEnd; index++) {
          const h = index % 24
          let text1 = ''
          if (h < 10) {
            text1 = '0' + h
          } else {
            text1 = h
          }
          valueArray1.push({ text: text1, value: h })
        }
        valueArray2 = _15Step
        
      } else {
        for (let index = 0; index <= 23; index++) {
          let text1 = ''
          if (index < 10) {
            text1 = '0' + index
          } else {
            text1 = index
          }
          valueArray1.push({ text: text1, value: index })
        }
        for (let index = 0; index <= 59; index++) {
          let text = ''
          if (index < 10) {
            text = '0' + index
          } else {
            text = index
          }
          valueArray2.push({ text: text, value: index })
        }
      }

      this.columns = [{
        values: valueArray1,
        defaultIndex: this.timeDefaultIndex1
      },
      {
        values: valueArray2,
        defaultIndex: this.timeDefaultIndex2
      }]
    },
    onTimeChange(picker, values) {
      if (this.currentStyle == 6) {
      } else if (this.currentStyle == 7) {
        if (values[0].text == '08') {
          picker.setColumnValues(1, [{ text: '00', value: 0 }]);
        } else { 
          picker.setColumnValues(1, _15Step);
        }
      } else if (this.currentStyle == 8) {
        if (values[0].text == '12') {
          picker.setColumnValues(1, [{ text: '00', value: 0 }]);
        } else {
          picker.setColumnValues(1, _15Step);
        }
      }
    }
  },

}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";

.question-view {
  width: 100%;
  display: flex;
  flex-direction: column;

  &-title {
    color: #323233;
    font-size: 16px;
    line-height: 20px;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 17px;
  }

  &-title-child {
    margin-top: 10px;
  }

  &-options {
    margin-top: 35px;

    &-cell {
      background-color: white;
      box-sizing: border-box;
      padding: 0px 15px 0px 15px;

      &-container {
        font-size: 14px;
        border-bottom: 1px solid #ebedf0;
        height: 44px;
        display: flex;
        align-items: center;

        &-last {
          border-bottom: 1px solid white !important;
        }
      }
    }
  }

  &-choice {
    margin-top: 35px;
    padding: 0px 15px 0px 15px;
    background-color: white;
    font-size: 14px;
    height: 44px;
    display: flex;
    align-items: center;
  }

  &-input {
    margin-top: 35px;
    padding: 0px 15px 0px 15px;
    background-color: white;
    font-size: 14px;
    height: 44px;
    display: flex;
    align-items: center;
  }

  &-input-child {
    margin-top: 10px;
  }

  &-mix {
    background-color: white;
    margin-top: 35px;
    padding: 0px 15px 0px 15px;

    &-input {

      height: 44px;
      border-bottom: 1px solid #ebedf0;
      display: flex;
      align-items: center;
    }

    &-radio {
      height: 44px;
      border-bottom: 1px solid #ebedf0;
      display: flex;
      align-items: center;
    }
  }
}
</style>
